<div
    class="entry"
    [class.weblink--outlined]="outlined"
>
    @if (title) {
        <h3
            class="entry__title"
        >
            {{ title }}
        </h3>
    }

    @if (safeLink) {
        <a
            class="entry__link"
            target="_blank"
            [attr.aria-label]="ariaLabel ?? linkLabel ?? link"
            [href]="safeLink"
        >
      <span>
        {{ linkLabel ?? link }}
      </span>
            <i
                aria-hidden="true"
                class="pi pi-chevron-right"
            ></i>
        </a>
    }
</div>
